var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v("< Back")])}
var staticRenderFns = []

export { render, staticRenderFns }